import { environment } from 'src/environments/environment';

// Query parameter name the backend's HubCaptureFilter reads in OnConnectedAsync - native browser
// WebSockets cannot set custom headers on the upgrade request, so this rides in the connection
// URL instead, the same channel accessTokenFactory already uses for the JWT and for the same
// reason.
export const SESSION_QUERY_PARAM = 'sessionId';

const SESSION_NAME_ENDPOINT = `${environment.apiUrl}/User/sessionName`;

// Raw fetch, not HttpClient: SessionCorrelationInterceptor awaits this exact promise before
// attaching the session header to an API call, so routing this fetch through HttpClient would
// deadlock the very first request against itself. Fetched once and cached for the page's lifetime
// - the name is server-authoritative (see SessionNameService), the frontend only displays and
// forwards it.
let sessionNamePromise: Promise<string | undefined> | undefined;

export function getSessionName(): Promise<string | undefined> {
    if (!sessionNamePromise) {
        sessionNamePromise = fetch(SESSION_NAME_ENDPOINT)
            .then(response => (response.ok ? (response.json() as Promise<string>) : undefined))
            .catch(() => undefined);
    }
    return sessionNamePromise;
}

// Appends the session name to a SignalR hub URL's query string - see SESSION_QUERY_PARAM. A
// no-op (returns the URL unchanged) when the name has not resolved.
export function withSessionName(hubUrl: string, sessionName: string | undefined): string {
    if (!sessionName) {
        return hubUrl;
    }
    const separator = hubUrl.includes('?') ? '&' : '?';
    return `${hubUrl}${separator}${SESSION_QUERY_PARAM}=${encodeURIComponent(sessionName)}`;
}
